module.exports = __webpack_public_path__ + "img/ng.cc34b827.svg";